// extracted by mini-css-extract-plugin
export default {"paragraph":"GroupFieldInfoModal_paragraph__yIJjH","image":"GroupFieldInfoModal_image__5Sq8R"};